module.exports = __webpack_public_path__ + "static/media/pdf_file_icon.cad028c1.svg";